
require("clover/panel/base/BasePanel")
require("clover/ui/HeadImageLoader")
const GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")

let QQLightgameChooseUserDataPanel = xClass("QQLightgameChooseUserDataPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_mergedata_panel_mergedata.csb")
})

QQLightgameChooseUserDataPanel.show = function (parent, data, callback, failCb) {
    var onSuccess = function(){
        var panel = QQLightgameChooseUserDataPanel.create(data, callback);
        panel.popup();
        parent.addChild(panel);
        cc.log("QQLightgameChooseUserDataPanel", panel)
    }
    var onFail = failCb || Toast.make(getText("error.tip.load_res_error"));
    var onCancel = failCb || Toast.make(getText("error.tip.load_canceled"));

    var res = [
        "font/berlinsansfb_70_nostroke.fnt",
        "font/zzgftongxin_40_brownstroke.fnt",
        "font/zzgftongxin_40_aquastroke.fnt",
        "font/berlinsansfb_40_brownstroke.fnt",
        "font/zzgftongxin_40_greenstroke.fnt",
        "font/zzgftongxin_70_greenstroke.fnt",
        "cocos/uilibrary.plist",
        "cocos/commonLib.plist",
        "cocos/panel_mergedata.plist",
        "cocos/panel_mergedata_btn_blue_back.csb",
        "cocos/panel_mergedata_btn_blue_consume.csb",
        "cocos/panel_mergedata_button_green_confirm.csb",
        "cocos/panel_mergedata_display.csb",
        "cocos/panel_mergedata_goldcoin.csb",
        "cocos/panel_mergedata_panel_confirmproject.csb",
        "cocos/panel_mergedata_panel_mergedata.csb",
        "cocos/panel_mergedata_portrait.csb",
        "cocos/panel_mergedata_props_goldcoin.csb",
        "cocos/panel_mergedata_silvercoin.csb",
        "cocos/panel_mergedata_xlevel.csb"
    ];

    preloadWithLoading(res, onSuccess, onFail, onCancel, false);
}

QQLightgameChooseUserDataPanel.prototype.ctor = function (data, callback) {
    var self = this
    self.callback = callback;
    self.confirmNode = null;

    var qqLevel = data.user.user.topLevelId;
    var qqCash = data.user.user.cash;
    var qqCoin = Math.ceil(parseInt(data.user.user.coin)/10000);
    var qqName = data.nickname;
    var qqAvatar = data.avatar;
    var wanbaLevel = data.wanba_users.user.user.topLevelId;
    var wanbaCash = data.wanba_users.user.user.cash;
    var wanbaCoin = Math.ceil(parseInt(data.wanba_users.user.user.coin)/10000);
    var wanbaName = data.wanba_users.nickname;
    var wanbaAvatar = data.wanba_users.avatar;

    self.selectName = null;

    self.getChildByName("title").x += 150;
    var txt1 = self.getChildByName("txt1");
    var txt = "由于近期平台升级需要，我们将会合并空间小游戏和QQ小游戏的游戏数据。您在以上两个平台均有账号，请选择 1 个保留的账号作为QQ小游戏的账号。两个账号内的货币将合并至您选择保留的账号中。{c=236,40,43,255}\n【注意】您可能依然可以登录空间小游戏的账号，但合并操作仅可执行 1 次"
    var pos = cc.pAdd(txt1.getPosition(), cc.p(0, 20));
    txt1.removeFromParent();
    txt1 = GameGuideAnims.createMixedText(txt, 20, cc.c4b(211,116,69,255), 475, "left");
    txt1.setAnchorPoint(cc.p(0.5, 0.5));
    txt1.setPosition(pos);
    self.addChild(txt1);


    var qqFrame = self.getChildByName("display1");
    self.qqFrame = qqFrame;
    var wanbaFrame = self.getChildByName("display2")
    self.wanbaFrame = wanbaFrame;
    var qqTitle = qqFrame.getChildByName("txt");
    qqTitle.setString("QQ小游戏");
    qqTitle.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    qqTitle.setAnchorPoint(cc.p(0.5, 0.5));
    qqTitle.x += 120;
    qqTitle.y -= 15;
    qqFrame.getChildByName("name").setString(qqName);
    qqFrame.getChildByName("name").setFontWeight("bold");
    qqFrame.getChildByName("name").y -= 5;
    var qqLvTxt = qqFrame.getChildByName("xlevel").getChildByName("num");
    qqLvTxt.x += 46;
    qqLvTxt.y -= 15;
    qqLvTxt.setString(qqLevel);
    qqLvTxt.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    qqLvTxt.setContentSize(100, 30);
    qqLvTxt.setAnchorPoint(cc.p(0.5, 0.5));
    qqFrame.getChildByName("goldcoin").x -= 30;
    qqFrame.getChildByName("goldcoin").getChildByName("num").setString(qqCash);
    var silverNum = qqFrame.getChildByName("silvercoin").getChildByName("num");
    silverNum.setString(qqCoin);
    qqFrame.getChildByName("silvercoin").getChildByName("icon2").x = silverNum.x + silverNum.width/2;
    qqFrame.getChildByName("btn").getChildByName("label").x += 20;
    self.qqTick = qqFrame.getChildByName("tick");
    self.qqTick.setVisible(false);
    HeadImageLoader.loadImage(qqFrame.getChildByName("portrait"), qqAvatar);

    self.qqBtn = qqFrame.getChildByName("btn")
    self.qqBtn = UIButton.create(self.qqBtn)
    ButtonPushBounceAnim.create(self.qqBtn)
    ButtonPushBounceIdleBubbleAnim.create(self.qqBtn)
    self.qqBtn.on(UIButtonEvent.Click, function() {
        self.selectClick("qq_lightgame");
    })

    var wanbaTitle = wanbaFrame.getChildByName("txt");
    wanbaTitle.setString("空间小游戏");
    wanbaTitle.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    wanbaTitle.setContentSize(100, 30);
    wanbaTitle.setAnchorPoint(cc.p(0.5, 0.5));
    wanbaTitle.x += 120;
    wanbaTitle.y -= 15;
    wanbaFrame.getChildByName("name").setString(wanbaName);
    wanbaFrame.getChildByName("name").setFontWeight("bold");
    wanbaFrame.getChildByName("name").y -= 5;
    var wanbaLvTxt = wanbaFrame.getChildByName("xlevel").getChildByName("num");
    wanbaLvTxt.x += 46;
    wanbaLvTxt.y -= 15;
    wanbaLvTxt.setString(wanbaLevel);
    wanbaLvTxt.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
    wanbaLvTxt.setContentSize(100, 30);
    wanbaLvTxt.setAnchorPoint(cc.p(0.5, 0.5));
    wanbaFrame.getChildByName("goldcoin").x -= 30;
    wanbaFrame.getChildByName("goldcoin").getChildByName("num").setString(wanbaCash);
    var silverNum = wanbaFrame.getChildByName("silvercoin").getChildByName("num");
    silverNum.setString(wanbaCoin);
    wanbaFrame.getChildByName("silvercoin").getChildByName("icon2").x = silverNum.x + silverNum.width/2;
    wanbaFrame.getChildByName("btn").getChildByName("label").x += 20;
    self.wanbaTick = wanbaFrame.getChildByName("tick");
    self.wanbaTick.setVisible(false);
    HeadImageLoader.loadImage(wanbaFrame.getChildByName("portrait"), wanbaAvatar);

    self.wanbaBtn = wanbaFrame.getChildByName("btn")
    self.wanbaBtn = UIButton.create(self.wanbaBtn)
    ButtonPushBounceAnim.create(self.wanbaBtn)
    ButtonPushBounceIdleBubbleAnim.create(self.wanbaBtn)
    self.wanbaBtn.on(UIButtonEvent.Click, function() {
        self.selectClick("wanba_ts");
    })
}

QQLightgameChooseUserDataPanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(40-display.width/2, 1000-display.height/2));
    self.setScale(0.23)
    self.setPosition(display.width / 2 - 450, display.height / 2 - 450);
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

QQLightgameChooseUserDataPanel.prototype.selectClick = function(name){
    var self = this;
    if (self.confirmNode || self.selectName == name){
        return;
    }
    
    self.selectName = name;
    self.moveFrame = null;
    self.moveFramePrePos = null;
    if (self.selectName == "qq_lightgame"){
        self.qqFrame.getChildByName("btn").setVisible(false);
        self.qqFrame.getChildByName("tick").setVisible(true);
        self.wanbaFrame.getChildByName("btn").setVisible(true);
        self.wanbaFrame.getChildByName("tick").setVisible(false);
        self.moveFrame = self.qqFrame;
    }else if (self.selectName == "wanba_ts"){
        self.qqFrame.getChildByName("btn").setVisible(true);
        self.qqFrame.getChildByName("tick").setVisible(false);
        self.wanbaFrame.getChildByName("btn").setVisible(false);
        self.wanbaFrame.getChildByName("tick").setVisible(true);
        self.moveFrame = self.wanbaFrame;
    }
    self.moveFramePrePos = self.moveFrame.getPosition();
    self.showConfirm()
}

QQLightgameChooseUserDataPanel.prototype.showConfirm = function(){
    var self = this;

    self.confirmNode = cc.CSLoader.createNode("cocos/panel_mergedata_panel_confirmproject.csb");
    self.addChild(self.confirmNode, 100);

    var display = self.confirmNode.getChildByName("displayNode");
    var displayPos = display.getPosition();
    display.removeFromParent(true);
    self.moveFrame.removeFromParent(false);
    self.confirmNode.addChild(self.moveFrame);
    self.moveFrame.setPosition(displayPos);

    self.confirmNode.getChildByName("title").x += 130;

    self.confirmNode.getChildByName("btn_back").getChildByName("label").x += 20;
    self.confirmNode.getChildByName("btn_confirm").getChildByName("label").x += 20;

    self.cancelBtn = self.confirmNode.getChildByName("btn_back")
    self.cancelBtn = UIButton.create(self.cancelBtn)
    ButtonPushBounceAnim.create(self.cancelBtn)
    ButtonPushBounceIdleBubbleAnim.create(self.cancelBtn)
    self.cancelBtn.on(UIButtonEvent.Click, function() {
        self.cancelClick();
    })
    self.confirmBtn = self.confirmNode.getChildByName("btn_confirm")
    self.confirmBtn = UIButton.create(self.confirmBtn)
    ButtonPushBounceAnim.create(self.confirmBtn)
    ButtonPushBounceIdleBubbleAnim.create(self.confirmBtn)
    self.confirmBtn.on(UIButtonEvent.Click, function() {
        var choose = self.selectName
        self.confirmClick(choose);
    })

    var targetScale = self.confirmNode.getScale()
    self.confirmNode.setScale(0)
    var time = 7 / 30
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.p(170-display.width/2, 60-display.height/2);
    var pos_O = cc.p(0, 0)
    var startPoint = cc.p(self.confirmNode.width/2 + 40-display.width/2, 0-self.confirmNode.height/2 - 40-display.height/2);
    self.confirmNode.setScale(0.23)
    self.confirmNode.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.confirmNode.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
}

QQLightgameChooseUserDataPanel.prototype.cancelClick = function(){
    cc.log("cancelClick");
    var self = this;
    self.moveFrame.removeFromParent(false);
    self.addChild(self.moveFrame);
    self.moveFrame.setPosition(self.moveFramePrePos);
    
    self.moveFrame.getChildByName("btn").setVisible(true);
    self.moveFrame.getChildByName("tick").setVisible(false);

    var clearConfirm = function(){
        self.confirmNode.removeFromParentAndCleanup(true);
        self.confirmNode = null;
        self.selectName = null;
    }
    var time = 7 / 30
    var targetPos = cc.p(self.confirmNode.width/2 + 40-display.width/2, 0-self.confirmNode.height/2 - 40-display.height/2);
    self.confirmNode.runAction(cc.spawn(cc.sequence(cc.scaleTo(time, 0.23), cc.MoveTo.create(time, targetPos)), cc.callFunc(clearConfirm)));
}

QQLightgameChooseUserDataPanel.prototype.confirmClick = function(name){
    var self = this;
    cc.log("confirmClick", name);
    if (name){
        self.callback(name);
        self.removeFromParentAndCleanup(true);
    }else{
        return;
    }
}

module.exports = QQLightgameChooseUserDataPanel